var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.162,
    height: 35.941,
    viewBox: "0 0 35.162 35.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.844,
    y1: 0.151,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b6bb20",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.581,
    cy: 17.97,
    rx: 17.581,
    ry: 17.97,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.581,
    cy: 17.97,
    rx: 16.581,
    ry: 16.97,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.245,30.49A15.245,15.245,0,0,1,4.465,4.465a15.245,15.245,0,0,1,21.56,21.56A15.146,15.146,0,0,1,15.245,30.49ZM11.717,16.04h0L5.661,22.1H24.828L18.771,16.04,17.19,17.516a2.859,2.859,0,0,1-3.892,0l-1.58-1.475ZM25.905,9.382,19.885,15l6.02,6.02Zm-21.321,0V21.022L10.6,15Zm1.17-.991L14.339,16.4a1.329,1.329,0,0,0,1.812,0l8.585-8.012Z",
    transform: "translate(4.672 4.451)",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7c78f1509f58b4e40ecde9b51fe54d6b.svg";
export { ForwardRef as ReactComponent };